module.exports = __webpack_public_path__ + "static/media/qa.b29ed675.jpeg";